import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const ProjectCTASection = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleClick = () => {
    navigate('/votre-projet');
  };

  return (
    <section className="py-12 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0D9488 0%, #0F766E 100%)' }}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 translate-y-1/2" />
      </div>
      <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-6xl font-bold text-white mb-6">
          {language === 'fr' ? 'Parlez nous de votre projet' : 'Tell us about your project'}
        </h2>
        <button
          onClick={handleClick}
          className="group relative inline-flex items-center justify-center bg-white hover:bg-gray-50 text-teal-700 px-12 py-6 rounded-2xl font-bold text-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl"
        >
          <span className="relative z-10">
            {language === 'fr' ? 'Je me lance !' : 'Get Started!'}
          </span>
          <div className="absolute bottom-4 right-4 text-6xl opacity-20 group-hover:opacity-30 transition-opacity">
            👋
          </div>
        </button>
      </div>
    </section>
  );
};

export default ProjectCTASection;